import React from 'react';
import { LAYOUT } from '../styles/constants';
import useMediaQuery from '../hooks/useMediaQuery';
import Logo from './header/Logo';

const Header = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const logoSize = isDesktop ? 1 : 0.7;

  return (
    <div className="w-full flex justify-center">
      <header className="bg-primary w-full max-w-[1759px]">
        <div 
          className="w-full text-white"
          style={{ 
            height: isDesktop ? LAYOUT.HEADER_BANNER_HEIGHT : '120px'
          }}
        >
          <div className="max-w-[1762px] mx-auto px-4">
            <div className="flex items-center justify-between py-4">
              <Logo 
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Coat_of_arms_of_Tanzania.svg/200px-Coat_of_arms_of_Tanzania.svg.png"
                alt="Left Logo"
                width={Math.round(112 * logoSize)}
                height={Math.round(130 * logoSize)}
              />
              <div className="text-center font-inter font-black">
                <h1 className={`${isDesktop ? 'text-2xl' : 'text-lg'}`}>
                  MAHAKAMA KUU YA TANZANIA
                </h1>
                <h2 className={`${isDesktop ? 'text-xl' : 'text-base'}`}>
                  DIVISHENI YA BIASHARA
                </h2>
              </div>
              <Logo 
                src="https://upload.wikimedia.org/wikipedia/en/thumb/9/92/Judiciary_of_Tanzania_Logo.png/220px-Judiciary_of_Tanzania_Logo.png"
                alt="Right Logo"
                width={Math.round(125 * logoSize)}
                height={Math.round(123 * logoSize)}
              />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;